import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {
  ILimitedResult,
  Pagination,
  AuditClaimTag,
  ClaimWithSourceAndTagIds,
} from "../models";

import { Observable } from "rxjs";
import { environment } from "../../environments/environment";
import { HttpUtilityService } from "./http-utility.service";
import { GlobalFilterService } from "./global-filter.service";

const BASE_URL = `${environment.auditApiRoot.url}/clients`;

@Injectable({
  providedIn: "root",
})
export class AuditClaimTagService {
  private readonly Timeout: number = 30000;
  constructor(
    private http: HttpClient,
    private httpUtility: HttpUtilityService,
    private globalFilterService: GlobalFilterService
  ) {}

  public getAuditClaimTags(
    rawDataImport_ShardClaimIdentifier: number,
    source: string,
    pagination: Pagination
  ): Observable<ILimitedResult<AuditClaimTag>> {
    const url = `${BASE_URL}/${this.globalFilterService.selectedClientId}/Claims/${rawDataImport_ShardClaimIdentifier}/AuditClaimTags/Source/${source}`;
    const params = pagination.buildSearchParams();
    const headers = this.httpUtility.getHeaders();
    return this.http.get<ILimitedResult<AuditClaimTag>>(url, {
      headers,
      params,
    });
  }

  public deleteAuditClaimTags(
    claimWithSourceAndTags: ClaimWithSourceAndTagIds
  ): Observable<boolean> {
    const url = `${BASE_URL}/${this.globalFilterService.selectedClientId}/DeleteAuditClaimTags`;
    const headers = this.httpUtility.getHeaders();
    return this.http.post<boolean>(url, claimWithSourceAndTags, { headers });
  }
}
